import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=64c0eeda"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=64c0eeda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports